export default "__VITE_ASSET__BMWIBNfT__"